export default [
    {
        path: '/work',
        name: 'work',
        component: () => import('@/views/works/WorkView.vue'),
    },
    {
        path: '/activity',
        name: 'activity',
        component: () => import('@/views/works/ActivityView.vue'),
    },
]
